export const getAhoraCompleto = () => {
  const agregaCero = (numero) => (numero < 10 ? `0${numero}` : `${numero}`);
  const timeElapsed = Date.now();
  const today = new Date(timeElapsed);
  const y = today.getFullYear();
  const d = agregaCero(today.getDate());
  const M = agregaCero(today.getMonth() + 1);

  const h = agregaCero(today.getHours());
  const m = agregaCero(today.getMinutes());
  const s = agregaCero(today.getSeconds());

  return `${y}-${M}-${d} ${h}:${m}:${s}`;
};


